const listLoading = {
  inserted(el, binding) {
    createLoadingElement(el, binding);
    if (binding.value) {
      showLoading(el);
    }
  },
  
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      if (binding.value) {
        showLoading(el);
      } else {
        hideLoading(el);
      }
    }
    
    // 更新文本内容
    if (binding.arg !== binding.oldArg) {
      updateLoadingText(el, binding.arg);
    }
  },
  
  unbind(el) {
    hideLoading(el);
    restorePosition(el);
  }
};

function createLoadingElement(el, binding) {
  if (el.loadingEl) return;
  
  const { arg, modifiers } = binding;
  const text = arg || '加载中，请稍候...';
  const isFullscreen = modifiers.fullscreen;
  
  const maskClass = isFullscreen ? 'custom-loading-mask is-fullscreen' : 'custom-loading-mask';
  
  const loadingHtml = `
    <div class="${maskClass}">
      <div class="custom-loading-spinner">
        <div class="custom-loading-content">
          <div class="custom-loading-gif-container">
            <img src="/img/logo_motion_.gif" alt="加载中，请稍候..." class="custom-loading-gif">
          </div>
          <div class="custom-loading-text">${text}</div>
        </div>
      </div>
    </div>
  `;
  
  el.loadingEl = document.createElement('div');
  el.loadingEl.innerHTML = loadingHtml;
  
  // 保存配置
  el.loadingConfig = {
    text,
    isFullscreen
  };
  
  // 确保图片加载完成后显示
  const img = el.loadingEl.querySelector('img');
  if (img.complete) {
    img.style.opacity = '1';
  } else {
    img.style.opacity = '0';
    img.onload = function() {
      this.style.opacity = '1';
      this.style.transition = 'opacity 0.3s ease-in-out';
    };
    img.onerror = function() {
      // 图片加载失败时显示备用内容
      this.style.display = 'none';
      const container = this.parentElement;
      container.innerHTML = '<div class="custom-loading-placeholder"></div>';
    };
  }
  
  if (!isFullscreen) {
    ensurePosition(el);
  }
}

function ensurePosition(el) {
  const computedStyle = window.getComputedStyle(el);
  if (computedStyle.position === 'static') {
    el.originalPosition = computedStyle.position;
    el.style.position = 'relative';
    el.hasAddedPosition = true;
  }
}

function restorePosition(el) {
  if (el.hasAddedPosition) {
    el.style.position = el.originalPosition || 'static';
  }
}

function showLoading(el) {
  if (!el.loadingEl) return;
  
  const { isFullscreen } = el.loadingConfig;
  
  if (isFullscreen) {
    if (!document.body.contains(el.loadingEl)) {
      document.body.appendChild(el.loadingEl);
    }
  } else {
    if (!el.contains(el.loadingEl)) {
      ensurePosition(el);
      el.appendChild(el.loadingEl);
    }
  }
}

function hideLoading(el) {
  if (!el.loadingEl) return;
  
  const { isFullscreen } = el.loadingConfig;
  
  if (isFullscreen) {
    if (document.body.contains(el.loadingEl)) {
      document.body.removeChild(el.loadingEl);
    }
  } else {
    if (el.contains(el.loadingEl)) {
      el.removeChild(el.loadingEl);
    }
  }
}

function updateLoadingText(el, newText) {
  if (!el.loadingEl) return;
  
  const textEl = el.loadingEl.querySelector('.custom-loading-text');
  if (textEl) {
    textEl.textContent = newText || '加载中，请稍候...';
  }
}

export default {
  install(app) {
    app.directive('listLoading', listLoading)
  }
}